module.exports = __webpack_public_path__ + "img/default-user-url.c5c1175f.png";